<template>
    <div class="modal1">
        <div class="modal__content-container" style="width: auto;" :style="{ '--bg-gradient': skin.header_desktop?.sombra }">
            <div class="sign-in-desktop">
                <div v-if="skin.imagen.back" class="sign-in-desktop__background"  >
                    <img class="sign-in-desktop__background" :src="skin.imagen.back" alt="">
                </div>
                <form class="sign-in-desktop__form" :style="skin.side_bar.body1" @submit.prevent="login()">
                    <span class="sign-in-desktop__cross" @click="closeModal">
                        <svg style="width: 100%;height: 100%;" viewBox="0 0 43 43" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M26.3137 15L28.0108 16.6971L23.3538 21.354L28.3137 26.3139L26.6167 28.011L21.6567 23.0511L16.6971 28.0108L15 26.3137L19.9597 21.354L15.3029 16.6973L17 15.0002L21.6567 19.657L26.3137 15Z"
                                fill="#9583A0"></path>
                        </svg>
                    </span>
                    <span class="title">{{ translate('auto1') }}</span>
                    <div class="sign-in-desktop__fields">
                        <span class="sign-in-desktop__label">{{ translate('name') }} <span
                                class="sign-in-desktop__star"> *</span></span>
                        <input :style="skin.my_account.search" type="text" v-model="username" placeholder="Nombre"
                            class="input input_sizable_low input_type_text input_validState_1" required>
                        <span class="sign-in-desktop__label">{{ translate('pass') }} <span
                                class="sign-in-desktop__star">
                                *</span></span>
                        <div class="input__wrapper">
                            <span class="SVGInline input__password" @click="togglePassword">
                                <svg v-if="!showPassword" class="SVGInline-svg input__password-svg" viewBox="0 0 24 24"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.87301 17.129C5.02801 15.819 3.56801 14.115 2.74301 13.039C2.51231 12.742 2.38708 12.3766 2.38708 12.0005C2.38708 11.6244 2.51231 11.259 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C13.876 5 15.63 5.807 17.13 6.874"
                                        stroke="#76657E" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path
                                        d="M10 18.704C10.6492 18.8972 11.3227 18.9969 12 19C16.182 19 19.764 14.987 21.257 13.038C21.4876 12.7407 21.6127 12.3751 21.6125 11.9988C21.6124 11.6226 21.4869 11.2571 21.256 10.96C20.7313 10.2755 20.1684 9.62112 19.57 9M14.13 9.887C13.8523 9.60467 13.5214 9.38011 13.1565 9.22629C12.7916 9.07246 12.3998 8.99241 12.0038 8.99075C11.6078 8.98909 11.2154 9.06586 10.8491 9.21662C10.4829 9.36738 10.1502 9.58916 9.87016 9.86915C9.5901 10.1492 9.36824 10.4818 9.21739 10.848C9.06654 11.2142 8.98969 11.6066 8.99125 12.0026C8.99282 12.3986 9.07278 12.7904 9.22652 13.1554C9.38026 13.5203 9.60473 13.8512 9.887 14.129L14.13 9.887ZM4 20L20 4L4 20Z"
                                        stroke="#76657E" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </svg>
                                <svg v-else class="SVGInline-svg input__password-svg" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z"
                                        stroke="#76657E" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path
                                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                        stroke="#76657E" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </svg>
                            </span>
                            <input :style="skin.my_account.search" :type="showPassword ? 'text' : 'password'"
                                placeholder="Contraseña"
                                class="input input_sizable_low input_type_password input_with-eye input_validState_1"
                                v-model="password" required>
                        </div>
                    </div>
                    <div class="sign-in-desktop__button" style="margin-top: .875rem;" >
                        <button type="submit" class="button-desktop button-desktop_color_default"
                            :style="skin.header_desktop.nav_bar_text + skin.header_desktop.selection"
                            >
                            <span class="sign-in-desktop__button-text">{{ translate('enter') }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "login",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            username: "",
            password: "",
            resetPassword: false,
            showPassword: false,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    computed: {
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        async login() {
            if (this.login_inProcess) {
                return;
            }
            this.login_inProcess = true;
            if (this.resetPassword) {
                if (this.username != "") {
                    let reset = await axios.post(this.$store.getters["getDomain"] + "/swarm/remote/forgot_password", {
                        "email": this.username
                    })
                    if (reset.data.success) {
                        this.status.message = reset.data.message;
                        this.status.type = "success";
                    }
                    else {
                        this.status.message = reset.data.message;
                        this.status.type = "danger";
                    }
                    this.resetPassword = false;
                }
                else {
                    this.status.message = this.translate("input_email");
                    this.status.type = "danger";
                }
                this.login_inProcess = false;
            }
            else {
                let data = await this.$store.dispatch('login', { username: this.username, password: this.password });
                if (data == "success") {
                    this.closeModal();
                    this.$root.$emit('forceRender');
                    this.login_inProcess = false;
                    this.username = '';
                    this.password = '';
                    this.status.message = '';
                    this.$store.dispatch("notification/setNotificacion", {
                        msg: "!Éxito! La sesión ha sido iniciada",
                        status: "success",
                    });
                }
                else {
                    this.$store.dispatch("notification/setNotificacion", {
                        msg: data,
                        status: "error",
                    });
                    this.status.type = "danger";
                    this.login_inProcess = false;
                }
            }

        },
        reset_password() {
            this.resetPassword = true;
            this.login();
        },
        submitLogin() {
            this.login();
        },
        closeModal() {
            this.$emit('close');
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    }
}
</script>
<style>
.modal1 {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1200;
    background: rgba(0, 0, 0, .5019607843);
}

.modal__content-container {
    position: absolute;
    left: 51%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.sign-in-desktop {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.sign-in-desktop__background {
    position: relative;
    width: 23.063rem;
}

.sign-in-desktop__background::before {
    content: "";
    position: absolute;
    top: -0.1rem;
    left: -0.1rem;
    right: -0.1rem;
    bottom: -0.1rem;
    background:  var(--bg-gradient);
    z-index: -1;
    -webkit-filter: blur(1.5rem);
    filter: blur(1.5rem);
}

.sign-in-desktop__form {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 23.938rem;
    padding-bottom: 3.125rem;
    border-radius: .625rem;
    position: relative;
    margin: .8rem .8rem .8rem 0;
    left: -5px;
    top: 2px;
}

.sign-in-desktop__form::before {
    content: "";
    position: absolute;
    top: -0.2rem;
    left: -0.2rem;
    right: -0.2rem;
    bottom: -0.2rem;
    background:  var(--bg-gradient);
    z-index: -1;
    -webkit-filter: blur(1.5rem);
    filter: blur(1.5rem);
}

.sign-in-desktop__cross {
    margin: .625rem .625rem 0 auto;
    cursor: pointer;
    width: 2.688rem;
    height: 2.688rem;
}

.sign-in-desktop__cross1 {
    cursor: pointer;
    width: 2.688rem;
    height: 2.688rem;
}

.sign-in-desktop__fields {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 2.094rem 0;
}

.sign-in-desktop__label {
    font-size: .875rem;
    font-weight: 600;
    color: #fff;
    margin-bottom: 3px;
}

.input {
    display: block;
    width: 100%;
    min-height: 2.5rem;
    outline: none;
    padding-left: 1rem;
    color: #fff;
    font-weight: 400;
    font-size: .875rem;
    border: none;
    border-radius: 9.375rem;
}

.sign-in-desktop__star {
    color: #d31c32;
}

.input__wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
}

.input__password {
    position: absolute;
    right: .625rem;
    top: .45rem;
    cursor: pointer;
}

.input__password-svg {
    width: 1.5rem;
    height: 1.5rem;
}

.sign-in-desktop__button {
    height: 2.5rem;
    margin: 1px 2.094rem 0;
}

.button-desktop {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 1.25rem;
    border: none;
    user-select: none;
    font-size: .875rem;
    text-align: center;
    outline: none;
    border-radius: 6.25rem;
    white-space: nowrap;
    font-weight: 700;
}

.sign-in-desktop__button-text {
    font-size: .875rem;
    font-weight: 700;
    text-align: center;
    color: #fff;
}
</style>
<style scoped>
.centered-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    /* Asegúrate de que el div ocupe toda la altura del contenedor */
    margin-top: 1rem;
    /* Ajusta el margen superior según sea necesario */
}


.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.title {
    font-weight: 700;
    font-size: 1.625rem;
    line-height: 100%;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    -webkit-font-feature-settings: "pnum" on, "lnum" on;
    font-feature-settings: "pnum" on, "lnum" on;
    color: #fff;
    font-family: 'Roboto', Arial, sans-serif;
    margin-bottom: 1.875rem;
}

.search-filter-slots-desktop__input-wrapper {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    height: 40px;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-right: .625rem;
    /* background: linear-gradient(180deg, #320548 0%, #1f073a 100%); */
    /* border: var(--border); */
    border-radius: 6.25rem;
    overflow: hidden;
    position: relative;
    overflow: hidden;
    padding-left: .938rem;
}

.search-filter-slots-desktop__search-icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.search-filter-slots-desktop__input {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
}

.input-desktop {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
}

.search-filter-slots-desktop__input input {
    padding-left: .625rem;
    border: none;
    color: var(--color);
    font-weight: 600;
    font-size: .875rem;
}

.input-desktop__native {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 1.25rem;
    outline: none;
    border-radius: 5px;
    color: white;
    font-family: "Roboto", Arial, sans-serif;
    font-size: .875rem;
    font-weight: 700;
    line-height: .875rem;
}

.login-btn {
    width: 100%;
    border: none
}

.img-login {
    content: "";
    position: absolute;
    top: -5.1rem;
    left: -1.1rem;
    right: -0.1rem;
    z-index: 5;
}

.modal-dialog {
    justify-content: center;
}
</style>
